import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";



export function useBankFeedApi() {

    const callApi = useApiCall();

    const fetchBankTransData = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BANK_FEED.FETCH_LIST, data, onSuccess, onError);
    }

    const fetchRegisterTransData = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.VIEW_REGISTER.FETCH_LIST, data, onSuccess, onError);
    }

    const feedUpdate = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BANK_FEED.UPDATE, data, onSuccess, onError);
    }

    const feedBulkUpdate = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.BANK_FEED.BULK_UPDATE, data, onSuccess, onError);
}


    const exportTransactionsCsv = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.VIEW_REGISTER.EXPORT_CSV, data, onSuccess, onError);
    }
    const fetchBankTemplates = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BANK_FEED.FETCH_BANK_TEMPLATES, data, onSuccess, onError);
    }

    const addBankAccounts = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BANK_FEED.ADD_BANK_ACCOUNT, data, onSuccess, onError);
    }

    const addBankTemplate = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BANK_FEED.ADD_BANK_TEMPLATE, data, onSuccess, onError);
    }

    const requestBank = (data: FormData, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.BANK_FEED.REQUEST_BANK, data, onSuccess, onError);
    }

    return {
        fetchBankTransData,
        fetchRegisterTransData,
        feedUpdate,
        feedBulkUpdate,
        exportTransactionsCsv,
        fetchBankTemplates,
        addBankAccounts,
        addBankTemplate,
        requestBank
    }
}